import { useInProgressIssue } from '../in-progress-issue/index.tsx';
import { useIssueRestoreMeta } from '../issue-restore-meta/index.tsx';

// To be used in an unload prompt
export const useIsIssueRestoreSaving = (): boolean => {
	const [{ isSavingCounter: isSavingCounterInProgressIssue }] = useInProgressIssue();
	const [{ isSavingCounter: isSavingCounterIssueRestoreMeta }] = useIssueRestoreMeta();
	return !(isSavingCounterInProgressIssue === 0 && isSavingCounterIssueRestoreMeta === 0);
};
